// import Vue from 'vue';
import axios from "axios";

const state = {
	show: false,
	isSaf: false,
	userinfo: null,
	settings: localStorage.getItem("data-notifier-settings")
		? JSON.parse(localStorage.getItem("data-notifier-settings"))
		: null,
};

const persistSettings = (settings) => {
	localStorage.setItem("data-notifier-settings", JSON.stringify(settings));
};

const getDefaultSettings = () => {
	return Object.assign(
		{},
		{
			doNotShowAgain: false,
			next: {
				nextType: null,
				nextCb: null,
				nextRoute: null,
			},
		}
	);
};

const getters = {
	settings: (state) => {
		return state.settings ? state.settings : getDefaultSettings();
	},
	show: (state) => {
		return state.show;
	},
	isSaf: (state) => {
		return state.isSaf;
	},
	userinfo: (state) => {
		return state.userinfo;
	},
};

const mutations = {
	async setIsSaf(state) {
		const response = await axios.get(USERINFO_URL);
		console.log(response);
		state.isSaf = response.data.isSaf;
		state.userinfo = response.data;
	},
	setNext(state, next) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.next = next;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
	},
	toggleShow(state) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		state.show = !state.show;
		// Reset next if we're closing
		if (!state.show) {
			settings.next = {
				nextType: null,
				nextCb: null,
				nextRoute: null,
			};
		}
		state.settings = Object.assign({}, settings);
	},
	doNotShowAgain(state) {
		let settings = state.settings
			? Object.assign({}, state.settings)
			: getDefaultSettings();
		settings.doNotShowAgain = true;
		state.settings = Object.assign({}, settings);
		persistSettings(settings);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
